import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/system';
import { Typography } from '@mui/material';

// style for Link of react router dom
const StyledLink = styled(RouterLink)(({ theme }) => ({
    textDecoration: 'none',
    color: theme.palette.primary.main,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

type NavigatorProps = {
    label: string;
    url: string;
    color?: 'primary' | 'secondary';
    fontSize?: number;
};

const Navigator = ({
    label,
    url,
    color = 'primary',
    fontSize = 14,
}: NavigatorProps) => {
    return (
        <StyledLink to={url} target="_blank" rel="noopener noreferrer">
            <Typography
                variant="body1"
                color={`text.${color}`}
                fontSize={fontSize}>
                {label}
            </Typography>
        </StyledLink>
    );
};

export default Navigator;
